export default {
  paged: {
    select: 'id,name,isActive,status,connectorType,subscriptionId,configurations',
    searchSelect: ['name'],
    orderBy: 'name asc',
  },
};
